import React from "react";
import { PieChart, Pie, Cell, Label } from "recharts";
import { theme } from "../../../styles/theme";

const COLORS = [`${theme.colors.green.Verde_AgroReceita}`, `${theme.colors.yellow.Amarelo}`, `${theme.colors.red.Vermelho_erro}`];
const USERINFO = JSON.parse(localStorage.getItem("@userinfo"));

const GraphicCircle = ({ value, label, maxQuantity, isCredit }) => {
    const maxValue = USERINFO.contrato.agro_plan_config.nome_plano === "PLANO BASIC" && isCredit ? 20 : isCredit ? 40 : 50;

    const displayValue = value;
    const normalizedValue = value > maxValue ? maxValue : value;

    const data = [
        { value: normalizedValue },
        { value: maxValue - normalizedValue }
    ];

    const color = normalizedValue >= 10 ? COLORS[0] : (normalizedValue < 10 && normalizedValue >= 5) ? COLORS[1] : COLORS[2];

    return (
        <div style={{ textAlign: "center", width: "150px", height: "150px" }}>
            <PieChart width={150} height={150}>
                <Pie
                    data={data}
                    cx="50%"
                    cy="50%"
                    innerRadius={50}
                    outerRadius={55}
                    dataKey="value"
                    startAngle={450}
                    endAngle={1800}
                >
                    <Cell key="value" fill="#E0E0E0" />
                    <Cell key="remaining" fill={color} />
                    <Label
                        value={`${displayValue}`}
                        position="center"
                        style={{
                            fill: 'black',
                            fontSize: '2.7rem',
                            fontWeight: '900',
                        }}
                    />
                </Pie>
            </PieChart>
            <p>{label}</p>
        </div>
    );
};

export default GraphicCircle;
